import styled from 'styled-components'

import { TypeStyle, TypeStyleBodySmall, fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Body = styled.div<{ variant: 'default' | 'model-selector-only' }>`
  align-items: center;
  display: flex;
  ${o =>
    o.variant === 'model-selector-only' &&
    `
    padding: 12px ${o.theme.dimensions.layout.sidePadding.md}px;
    > :not(:first-child) {
      margin-inline-start: 24px;
    }
    border-bottom: 1px solid ${o.theme.color.deprecated.stoneLight};
    ${untilMd} {
      justify-content: space-between;
    }
  `}

  ${o =>
    o.variant === 'default' &&
    `
    padding: ${o.theme.spacing(4, 0, 0, 0)};
    ${untilMd} {
      padding: ${o.theme.spacing(4, 4, 0, 4)};
      margin-bottom: -8px;
    }
  `}

  ${fromMd} {
    justify-content: flex-end;
  }
`

export const LegacyButton = styled.button`
  ${TypeStyle.css.headlineMicro};
  flex-shrink: 0;
  font-weight: bold;
  margin: 0 -8px;
  text-decoration: underline;
  padding: 0 8px;
`

export const Description = styled(TypeStyle.BodyDefault)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 16px;

  ${untilMd} {
    display: none;
  }
`

export const StickyParent = styled.div`
  align-items: flex-end;
  bottom: 24px;
  display: flex;
  position: absolute;
  top: 0;
  width: 100%;
  ${Body} {
    background: white;
    border-radius: 5px;
    bottom: 24px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    margin: 0 auto;
    position: sticky;
    width: fit-content;
    z-index: ${o => o.theme.zIndex.foregroundContent};
  }
`

export const PillButtonCaption = styled(TypeStyleBodySmall)`
  font-weight: 700;
`

export const StandaloneCTAWrapper = styled.div<{
  $bottomPadding: string
}>`
  position: absolute;
  bottom: ${o => o.$bottomPadding};
  left: 16px;
  z-index: 1;

  ${fromMd} {
    display: none;
  }
`
